import { Component } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

import "./ArticleFormatter.scss"

@Component
export class ArticleFormatter extends ThemeComponent {

    private paragraphs: NodeListOf<HTMLElement> = this.querySelectorAll('p');
    private youtubeIframes: NodeListOf<HTMLIFrameElement> =
    this.querySelectorAll('iframe[src*="https://www.youtube.com/embed"]');
    private images: NodeListOf<HTMLImageElement> = this.querySelectorAll('img');

    init() {
        this.formatIframes();
        this.formatImages();
    }

    formatIframes() {
        if (this.youtubeIframes) {
            for (const iframe of this.youtubeIframes) {
                const iframeWapper = document.createElement('div');
                iframeWapper.classList.add('article-main__youtube-player');
                if (iframe.parentNode) {
                    iframe.parentNode.insertBefore(iframeWapper, iframe);
                    iframeWapper.appendChild(iframe);
                }
            }
        }
    }

    formatImages() {
        if (this.images) {

            // First we need to determin if there is a left float image
            // immediately followed by a right floated image, and if so we wrap them

            const imageDivs = this.querySelectorAll('div');

            for (const div of imageDivs) {
                const nextElementSibling = div.nextElementSibling as HTMLElement;
                if (nextElementSibling) {
                    const nextSiblingStyle = nextElementSibling.getAttribute('style');
                    if (nextSiblingStyle && nextSiblingStyle.includes('text-align: right;')) {
                        const rowWrapper = document.createElement('div');
                        rowWrapper.classList.add('article-main__image-row');
                        div.insertAdjacentElement('beforebegin', rowWrapper);
                        rowWrapper.appendChild(div);
                        rowWrapper.appendChild(nextElementSibling);
                    }
                }
            }

            for (const image of this.images) {

                const imageStyle = image.getAttribute('style');
                let imageFloat = null;
                if (imageStyle && imageStyle.includes('float: left;')) {
                    imageFloat = 'left';
                } else if (imageStyle && imageStyle.includes('float: right;')) {
                    imageFloat = 'right';
                }

                const imageWrapper = document.createElement('div');
                imageWrapper.classList.add('article-main__image');

                const parentElement = image.parentNode as HTMLElement;
                if (parentElement) {
                    parentElement.classList.add('article-main__image-wrapper');
                    parentElement.insertBefore(imageWrapper, image);
                    imageWrapper.appendChild(image);
                    if (imageFloat) {
                        image.setAttribute('style', '');
                        parentElement.classList.add(`article-main__image-wrapper--${imageFloat}`);
                    }
                }

                if (image.alt != '' && !image.alt.includes('Image of ')) {
                    const altText = image.alt;
                    const imageAltWrapper = document.createElement('div');
                    imageAltWrapper.classList.add('article-main__image-alt');
                    imageAltWrapper.innerText = altText;
                    imageWrapper.appendChild(imageAltWrapper);
                }
            }
        }
    }
}
